/**
 * A planted street tree in its bed (lifted from lantern-water's `world.js`
 * `tree` and `street-tree.js`): a stone kerb ring, a grass bed, forty moss
 * tufts, the forked tree, and twenty fallen leaves around it. Origin at the
 * trunk, on the ground the placement stands on.
 *
 * Params: `size` (1): the tree's scale (bed radius 0.97 × size); `autumn`
 * (false): amber leaves and brass-coloured fallen leaves. The bed's walking
 * surface and the trunk's collider are the scene record's.
 */
import * as THREE from 'three';
import { flag, num } from '../kit.ts';
import { streetTree } from '../street-tree-model.ts';
import type { Prefab } from './types.ts';

export const prefab: Prefab = {
  id: 'street_tree',
  buildPrefab(ctx) {
    const root = new THREE.Group();
    const { box, cylinder, mesh, m, random } = ctx;
    const size = num(ctx, 'size', 1);
    const autumn = flag(ctx, 'autumn', false);
    cylinder(root, 0, 0.03, 0, 1.06 * size, 0.05, m.stone);
    cylinder(root, 0, 0.052, 0, 0.97 * size, 0.04, m.grass);
    for (let i = 0; i < 40; i += 1) {
      const a = random() * Math.PI * 2;
      const d = (0.3 + random() * 0.7) * size;
      const xx = Math.cos(a) * d;
      const zz = Math.sin(a) * d;
      const h = 0.08 + random() * 0.12;
      const geo = new THREE.BufferGeometry();
      geo.setAttribute('position', new THREE.Float32BufferAttribute([xx - 0.025, 0.074, zz, xx + 0.025, 0.074, zz, xx + 0.04, h + 0.074, zz + 0.02], 3));
      geo.setAttribute('uv', new THREE.Float32BufferAttribute([0, 0, 1, 0, 0.5, 1], 2));
      geo.computeVertexNormals();
      mesh(root, geo, m.moss, 0, 0, 0);
    }
    streetTree(ctx, root, ctx.leafMats[autumn ? 1 : 0], 0, 0, size, Math.floor(random() * 0x7fffffff) + 6871);
    for (let i = 0; i < 20; i += 1) {
      const a = random() * 6.28;
      const d = random() * size * 2;
      box(root, Math.cos(a) * d, 0.018, Math.sin(a) * d, 0.045, 0.015, 0.09, autumn ? m.brass : m.moss);
    }
    return { root };
  },
};
